import { useQuery } from "@tanstack/react-query";
import {
	fetchTemplates,
	type GetTemplatesParams,
	getShiftParameters,
} from "../repositories/TemplatesRepositorie";

export const TEMPLATES_QUERY_KEYS = {
	all: ["templates"] as const,
	list: (params: GetTemplatesParams) =>
		["templates", "list", params] as const,
	shiftParameters: (assetId: number | string) =>
		["templates", "shiftParameters", assetId] as const,
};

export const useTemplates = (params: GetTemplatesParams, enabled = true) => {
	const query = useQuery({
		queryKey: TEMPLATES_QUERY_KEYS.list(params),
		queryFn: () => fetchTemplates(params),
		enabled,
	});

	return {
		templates: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error as Error | null,
	};
};

export const useShiftParameters = (
	assetId: number | string,
	enabled = true,
) => {
	return useQuery({
		queryKey: TEMPLATES_QUERY_KEYS.shiftParameters(assetId),
		queryFn: () => getShiftParameters(assetId),
		enabled,
		staleTime: 5 * 60 * 1000,
	});
};
